// src/components/sections/Testimonial/Testimonial.jsx
import React, { useState, useRef, useEffect } from 'react';
import './testimonials.css';

const isMobile = () => window.innerWidth <= 768;

const Testimonial = ({ data }) => {
  const [currentIdx, setCurrentIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const [showButtons, setShowButtons] = useState(!isMobile());
  const intervalRef = useRef();
  const touchStartX = useRef(null);

  const total = data?.length || 0;

  useEffect(() => {
    const handleResize = () => setShowButtons(!isMobile());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    clearInterval(intervalRef.current);
    if (!paused && total > 0) {
      intervalRef.current = setInterval(() => {
        setCurrentIdx(prev => (prev + 1) % total);
      }, 5000);
    }
    return () => clearInterval(intervalRef.current);
  }, [paused, total]);

  if (!data || total === 0) return null;

  const next = () => setCurrentIdx(prev => (prev + 1) % total);
  const prev = () => setCurrentIdx(prev => (prev - 1 + total) % total);

  // Swipe handlers
  const handleTouchStart = e => {
    touchStartX.current = e.touches[0].clientX;
    setPaused(true);
  };
  const handleTouchEnd = e => {
    const startX = touchStartX.current;
    if (startX === null) return;
    const deltaX = e.changedTouches[0].clientX - startX;
    if (Math.abs(deltaX) > 45) deltaX > 0 ? prev() : next();
    touchStartX.current = null;
    setPaused(false);
  };

  const handleMouseEnter = () => !isMobile() && setPaused(true);
  const handleMouseLeave = () => !isMobile() && setPaused(false);

  const item = data[currentIdx];
  // parseo decimal y cálculo de estrellas
  const rating = Math.min(5, Math.max(0, parseFloat(item.estrellas) || 0));
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating - fullStars >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div
      className="testimonial-carousel"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={isMobile() ? handleTouchStart : undefined}
      onTouchEnd={isMobile() ? handleTouchEnd : undefined}
    >
      <div className="testimonial-carousel__inner">
        <div className="testimonial-carousel__item active">
          <div className="testimonial">
            <div className="testimonial__avatar">
              <span>{item.nombre?.charAt(0).toUpperCase()}</span>
            </div>
            <h3 className="testimonial__name">{item.nombre}</h3>
            <p className="testimonial__comment">"{item.comentario}"</p>
            <div className="testimonial__stars">
              {/* Estrellas llenas */}
              {Array.from({ length: fullStars }).map((_, i) => (
                <span key={`star-full-${i}`} className="star filled">★</span>
              ))}
              {/* Media estrella si tocó */}
              {hasHalfStar && <span className="star half">★</span>}
              {/* Estrellas vacías */}
              {Array.from({ length: emptyStars }).map((_, i) => (
                <span key={`star-empty-${i}`} className="star empty">☆</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {showButtons && (
        <>
          <button className="carousel-btn prev" aria-label="Anterior" onClick={prev}>
            <svg width="32" height="32" viewBox="0 0 24 24">
              <polyline points="15 18 9 12 15 6" fill="none" stroke="currentColor" strokeWidth="2" />
            </svg>
          </button>
          <button className="carousel-btn next" aria-label="Siguiente" onClick={next}>
            <svg width="32" height="32" viewBox="0 0 24 24">
              <polyline points="9 6 15 12 9 18" fill="none" stroke="currentColor" strokeWidth="2" />
            </svg>
          </button>
        </>
      )}

      <div className="testimonial-carousel__dots">
        {data.map((_, idx) => (
          <span
            key={idx}
            className={`dot${currentIdx === idx ? ' active' : ''}`}
            onClick={() => setCurrentIdx(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default Testimonial;
